import { render, staticRenderFns } from "./CitizenDialog.vue?vue&type=template&id=73e3fab0&scoped=true"
import script from "./CitizenDialog.vue?vue&type=script&lang=js"
export * from "./CitizenDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e3fab0",
  null
  
)

export default component.exports